module.exports = __webpack_public_path__ + "img/eye.2f2b93d0.svg";